export const DefaultWornLimit = 1;

export const WornLimits = {
    'Ring': 2
}